import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const BrowserNotSupportedLoader: LoadableType<{}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-srcBrowserNotSupported" */ '../src/BrowserNotSupported.tsx'
			)
		).BrowserNotSupported,
});
